import { useGoogleLogin } from "@react-oauth/google";
import axios, { AxiosError } from "axios";
import { Text } from "components/core/Text";
import { fireEvent } from "lib/ga";
import Image from "next/image";
import { useRouter } from "next/router";

import { Button } from "./Button";

type GoogleLoginButtonProps = {
    onSuccess?: () => Promise<void> | void;
    onError?: (error: Error) => void;
};

export const GoogleLoginButton = ({
    onSuccess,
    onError
}: GoogleLoginButtonProps) => {
    const router = useRouter();

    const googleSignIn = useGoogleLogin({
        flow: "auth-code",
        redirect_uri: window.location.origin,
        onSuccess: async (response) => {
            const code = response.code;

            try {
                const { data } = await axios.post("/api/oauth/google", {
                    code,
                    redirect_uri: window.location.origin
                });

                fireEvent({
                    event: "login",
                    params: {
                        method: "google",
                        prev_webview_access:
                            router.query.prev_webview_access === "true"
                    }
                });

                if (data.isNewUser) {
                    router.replace({
                        hash: "#signup-form"
                    });
                } else {
                    // 로그인 성공 시 이벤트성 쿠키(mix/modal) 바로 삭제
                    // TODO: 2025-08-22 이후 해당 부분 삭제가 필요함.
                    document.cookie = `mix/modal=; path=/; domain=${window.location.hostname}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
                    await onSuccess?.();
                    router.reload(); // clear gtm static params
                }
            } catch (error) {
                if (error instanceof AxiosError) {
                    window.alert(error.response?.data);
                    onError?.(error);
                }
            }
        }
    });

    return (
        <Button
            onClick={() => googleSignIn()}
            className="w-full rounded-xl !bg-white py-4
                shadow-[0px_3px_6px_rgba(0,0,0,0.16),0px_3px_6px_rgba(0,0,0,0.23)]"
        >
            <div className="relative mr-3 h-[22px] w-[22px]">
                <Image alt="google" src="/img/google.png" fill />
            </div>
            <Text className="text-black" variant="subtitle2">
                구글 로그인
            </Text>
        </Button>
    );
};
